const config = {
    // apiUrl: "http://ec2-43-204-17-21.ap-south-1.compute.amazonaws.com:8000",
    apiUrl: process.env.REACT_APP_API_URL,
};
export default config;
